import { useLocaleStore } from "~/stores/locale"
import { hasSubLocalePrefix } from "~/utils/locale"
// todo release not needed? for compatibility with api now
// middleware for  redirecting from  /route to /lang/route on sublocale domains
export default defineNuxtRouteMiddleware((to, _from) => {
  const localeStore = useLocaleStore()
  const localePath = `/${localeStore.subLocaleLang}`
  if (localeStore.subLocaleLang && !hasSubLocalePrefix(to.path, localeStore.subLocaleLang)) {
    // Carry the query and hash across: `to.path` alone dropped them. AB#63988
    return navigateTo({ path: `${localePath}${to.path}`, query: to.query, hash: to.hash })
  }
})
